module.exports = __webpack_public_path__ + "img/logo256.75d3a0a5.png";